exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#diagramm[data-v-da98f512]{min-width:350px}.attribute[data-v-da98f512],.klassenname[data-v-da98f512],.methoden[data-v-da98f512]{padding:5px;box-shadow:2px 0 0 0 #888,0 2px 0 0 #888,2px 2px 0 0 #888,inset 2px 0 0 0 #888,inset 0 2px 0 0 #888}.klassenname[data-v-da98f512]{text-align:center}input[data-v-da98f512]{border:none}.klassenname input[data-v-da98f512]{font-size:large;text-align:center}.attribute input[data-v-da98f512],.methoden input[data-v-da98f512]{font-size:medium;width:87%}.new[data-v-da98f512]{opacity:0;text-align:center}.new[data-v-da98f512]:hover{opacity:.5}.move[data-v-da98f512],.remove[data-v-da98f512]{opacity:0}.attribut:hover .move[data-v-da98f512],.attribut:hover .remove[data-v-da98f512],.methode:hover .move[data-v-da98f512],.methode:hover .remove[data-v-da98f512]{opacity:.5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-da98f512","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Diagramm.vue
// module id = 17
// module chunks = 0